import { useSearchParams } from 'react-router-dom';

export function useQueryParam(key: string) {
  const [params] = useSearchParams();
  return params.get(key);
}
